import {
  CheckIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline"
import { capitalize } from "lodash"

export type ConnectionStatus =
  | "healthy"
  | "unhealthy"
  | "error"
  | "warning"
  | "pending_setup"

export const getConnectionStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "healthy":
      return "#13CE66"
    case "error":
      return "#E2323E"
    case "pending_setup":
    case "warning":
    default:
      return "#F4D148"
  }
}

export const renderStatusIcon = (status: ConnectionStatus) => {
  switch (status) {
    case "healthy":
      return (
        <div className="flex items-center gap-2 bg-system-success-600 p-1.5 rounded-system-sm">
          <CheckIcon className="w-4 h-4 text-white" strokeWidth={2} />
        </div>
      )
    case "error":
      return (
        <div className="flex items-center gap-2 bg-system-error-600 p-1.5 rounded-system-sm">
          <XMarkIcon className="w-4 h-4 text-white" strokeWidth={2} />
        </div>
      )
    case "warning":
    case "pending_setup":
      return (
        <div className="flex items-center gap-2 bg-system-warning-600 p-1.5 rounded-system-sm">
          <ExclamationTriangleIcon
            className="w-4 h-4 text-white"
            strokeWidth={2}
          />
        </div>
      )
    default:
      return (
        <div className="flex items-center gap-2 bg-system-warning-600 p-1.5 rounded-system-sm">
          <ExclamationTriangleIcon
            className="w-4 h-4 text-white"
            strokeWidth={2}
          />
        </div>
      )
  }
}

export const renderHealthIndicator = (status: string) => {
  const color = getConnectionStatusColor(status)

  return (
    <p
      className="text-4 leading-7 font-medium flex items-center gap-2"
      style={{
        color,
      }}
    >
      {capitalize(status)}
      <div
        className="w-4 h-4 rounded-[50%]"
        style={{ backgroundColor: color }}
      />
    </p>
  )
}
